import dayjs from 'dayjs'

import permanentDstPlugin from './dayjs-permanent-dst'

/**
 * Side-effect import for each app's entry point.
 *
 * dayjs is a singleton, so extending it once here patches every `.tz()` call
 * in the bundle — including the screens that reach for dayjs directly instead
 * of going through `ts-utils`. Import it as early as the polyfills: a game row
 * rendered before this runs would be an hour out for a viewer in a province
 * that abolished its clock change. See `dayjs-permanent-dst`.
 */
dayjs.extend(permanentDstPlugin)
